import { createElement } from 'react';
import { Input as OriginalInput } from 'antd';
const TextArea = function TextArea({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalInput.TextArea, { rows: 4, ..._otherProps }));
};
export default TextArea;
